import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Button,
   Grid,
   IconButton,
   Paper,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { useForm } from 'react-hook-form';
import { endOfDay, format } from 'date-fns';
import { enUS, th } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import { DatePicker, useDateInput } from 'react-nice-dates';
import { TitleLabel } from '../../Element/LabelInputForm';
import Axios from 'axios';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import { AlertLabel, Input } from '../../../assets/styled/Element';
import SelectMultiAll from '../../Select/SelectMultiAll';
import LoadingPopup from '../../Loading/LoadingPopup';

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '40%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
      height: '550px',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));
const CreateReportRedemption = (props) => {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const [rewardRes, setRewardRes] = useState([]);
   const [optionsReward, setOptionsReward] = useState([]);
   const [rewardLoading, setRewardLoading] = useState(false);
   const closeRef = useRef();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const { handleSubmit, register, errors, watch, setValue, getValues } =
      useForm({
         defaultValues: {
            reward: [],
         },
      });
   const [errorSelectItem, setErrorSelectItem] = useState(false);
   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');
   const selectedReward = watch('reward');
   useEffect(() => {
      register({ name: 'startDate' });
      register({ name: 'endDate' });
      register({ name: 'reward' }, { required: true });
   }, [register]);
   useEffect(() => {
      getReward();
   }, []);
   const setsSelectedReward = (e) => setValue('reward', e);
   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };
   const timeStartInputProps = useDateInput({
      date: getValues('startDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleStartDateChange,
   });
   const timeEndInputProps = useDateInput({
      date: getValues('endDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleEndDateChange('manual'),
   });
   const getReward = () => {
      setRewardLoading(true);
      Axios.get('/GSB/dashboard/reward/GetList')
         .then((response) => {
            setRewardRes(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         });
   };
   useEffect(() => {
      setReward();
   }, [rewardRes]);
   const setReward = () => {
      if (rewardRes.length > 0) {
         const formatted = rewardRes.map((value) => {
            return Object.assign(
               {},
               {
                  value: value.rewardId,
                  label: value.rewardTh,
               },
            );
         });
         setRewardLoading(false);
         setOptionsReward(formatted);
      }
   };
   const onSubmit = (e) => {
      if (e.reward.length === 0) {
         setErrorSelectItem(true);
         return false;
      } else {
         setErrorSelectItem(false);
         sessionStorage.setItem('value', JSON.stringify(e));
         if (sessionStorage['value']) {
            const values = JSON.parse(sessionStorage.getItem('value'));
            postData(values);
         }
      }
   };
   const postData = (values) => {
      setIsLoading(true);
      const result = {
         rewardList:
            values.reward.length !== 0
               ? values.reward.map(({ value }) => value)
               : null,
         startDate: values.startDate
            ? format(new Date(values.startDate), 'dd/MM/yyyy HH:mm:ss')
            : null,
         endDate: values.endDate
            ? format(new Date(values.endDate), 'dd/MM/yyyy HH:mm:ss')
            : null,
      };
      Axios.post('/GSB/dashboard/report/GetRewardRedemptionReport', result)
         .then((resp) => {
            enqueueSnackbar('สร้างรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Typography variant={'h4'}>ตัวกรองรายงานการแลกของรางวัล</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={2}>
                     <Grid item xs={12}>
                        <TitleLabel Fs={'14px'}>
                           ชื่อของรางวัล
                           {errorSelectItem && (
                              <AlertLabel>
                                 กรุณาเลือกของรางวัลอย่างน้อย 1 อย่าง
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <SelectMultiAll
                           options={optionsReward}
                           isLoading={rewardLoading}
                           value={selectedReward}
                           onChange={setsSelectedReward}
                           placeholder={'เลือกของรางวัล'}
                           isDisabled={rewardLoading}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           เลือกระยะวันที่และเวลาของรายงาน
                           {(errors.startDate || errors.endDate) && (
                              <AlertLabel>
                                 กรุณาเลือกระยะวันที่และเวลาของรายงาน
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectStartDate}
                              onDateChange={handleStartDateChange}
                              locale={enUS}
                           >
                              {({ inputProps, focused }) => (
                                 <Box width={'100%'}>
                                    <Input
                                       className={
                                          'input' + (focused ? ' -focused' : '')
                                       }
                                       {...inputProps}
                                       value={`${
                                          inputProps.value &&
                                          dayjs(
                                             new Date(inputProps.value),
                                          ).format('DD/MM/BBBB')
                                       }`}
                                       width={'52%'}
                                       margin={'0px 3% 0px 0px'}
                                       placeholder={'เลือกวันที่'}
                                       readOnly
                                    />
                                    <Input
                                       className={'input'}
                                       {...timeStartInputProps}
                                       width={'45%'}
                                       type={'time'}
                                    />
                                 </Box>
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>&nbsp;</TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectEndDate}
                              onDateChange={handleEndDateChange('auto')}
                              locale={enUS}
                           >
                              {({ inputProps, focused }) => (
                                 <Box width={'100%'}>
                                    <Input
                                       className={
                                          'input' + (focused ? ' -focused' : '')
                                       }
                                       {...inputProps}
                                       value={`${
                                          inputProps.value &&
                                          dayjs(
                                             new Date(inputProps.value),
                                          ).format('DD/MM/BBBB')
                                       }`}
                                       width={'52%'}
                                       margin={'0px 3% 0px 0px'}
                                       placeholder={'เลือกวันที่'}
                                       readOnly
                                    />
                                    <Input
                                       className={'input'}
                                       {...timeEndInputProps}
                                       width={'45%'}
                                       type={'time'}
                                    />
                                 </Box>
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                  </Grid>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        สร้างรายการ
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </form>
      </Paper>
   );
};

export default CreateReportRedemption;
